var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.46967 10.7197C0.176777 11.0126 0.176777 11.4874 0.46967 11.7803C0.744257 12.0549 1.17879 12.0721 1.47337 11.8318L1.53033 11.7803L6.78033 6.53033C7.05492 6.25574 7.07208 5.82121 6.83181 5.52663L6.78033 5.46967L1.53033 0.21967C1.23744 -0.0732233 0.762563 -0.0732233 0.46967 0.21967C0.195083 0.494257 0.177921 0.928788 0.418185 1.22337L0.46967 1.28033L5.1895 6L0.46967 10.7197Z",
    fill: "#516A93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.d5644384a4953aedb392461e4da9697d.svg";
export { ForwardRef as ReactComponent };